import {
  REPORTS_DATABASE_NAME,
  REPORTS_DATABASE_OBJECT_STORE_KEY,
  REPORTS_DATABASE_OBJECT_STORE_NAME,
  REPORTS_DATABASE_VERSION,
} from '@/core/constants/reportsDatabase';
import { ReportsDatabaseUserReports } from '@/core/interfaces/common';

export const getReportDatabaseConnection = (setDbCallback: (dbConnection: IDBDatabase) => void) => {
  const databaseConnection = window.indexedDB.open(REPORTS_DATABASE_NAME, REPORTS_DATABASE_VERSION);

  databaseConnection.onupgradeneeded = () => {
    const updateDb = databaseConnection.result;

    updateDb.createObjectStore(REPORTS_DATABASE_OBJECT_STORE_NAME, {
      keyPath: REPORTS_DATABASE_OBJECT_STORE_KEY,
    });

    setDbCallback(updateDb);
  };

  databaseConnection.onsuccess = () => {
    setDbCallback(databaseConnection.result);
  };
};

export const getReportsDatabaseResults = async (
  authId: string
): Promise<ReportsDatabaseUserReports | null> => {
  const db: IDBDatabase | null = await new Promise(resolve => {
    getReportDatabaseConnection(resolve);
  });

  if (!db) {
    return null;
  }

  const reportsObjectStoreTransaction = db
    .transaction(REPORTS_DATABASE_OBJECT_STORE_NAME, 'readwrite')
    .objectStore(REPORTS_DATABASE_OBJECT_STORE_NAME);

  return await new Promise((resolve, reject) => {
    const reportsUserRequest = reportsObjectStoreTransaction.get(authId);

    reportsUserRequest.onsuccess = () => {
      if (reportsUserRequest.result) {
        resolve(reportsUserRequest.result as ReportsDatabaseUserReports);
      } else {
        resolve(null);
      }
    };
    reportsUserRequest.onerror = () => {
      reject(new Error('Failed to retrieve reports'));
    };
  });
};
